import { trackViewEvent, isHmBrand } from '@pb/utils'

import {
  getTabTracking,
  EVENT_TYPES,
  PAGE_ID,
  CATEGORY_PATH,
  getFavouritesTracking,
} from 'features/favourites/tracking'
import { RootState } from 'redux/types'

export const trackPill = (pill: string, state: RootState): void => {
  switch (true) {
    case pill === 'saved':
      trackViewEvent(getFavouritesTracking(state, EVENT_TYPES.favourites_view), true, isHmBrand)
      break
    case pill === 'styleboards':
      trackViewEvent(
        getTabTracking(
          EVENT_TYPES.my_styleboards_view,
          PAGE_ID.my_styleboards,
          CATEGORY_PATH.my_styleboards,
        ),
        true,
        isHmBrand,
      )
      break
    case pill === 'following':
      trackViewEvent(
        getTabTracking(
          EVENT_TYPES.following_styleboards_view,
          PAGE_ID.following_styleboards,
          CATEGORY_PATH.following_styleboards,
        ),
        true,
        isHmBrand,
      )
      break
    case pill === 'closet':
      trackViewEvent(
        getTabTracking(EVENT_TYPES.my_closet_view, PAGE_ID.my_closet, CATEGORY_PATH.my_closet),
        true,
        isHmBrand,
      )
      break
    default:
      break
  }
}
